// extracted by mini-css-extract-plugin
var _1 = "styles-module__button___Iskik";
var _2 = "styles-module__formButton___UG1a5";
export { _1 as "button", _2 as "formButton" }
